import React from 'react'

export const Dashboard = () => {


  return (
    <div className={'container'}>
      <h3> Dashboard </h3>

      <div className='row'>

        <div className='col-12 col-md-6'>

        </div>

        <div className='col-12 col-md-6'>

        </div>

      </div>

    </div>
  )
}
